import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import AsyncSelect from 'react-select/async';
import { debounce } from 'lodash';

const AutoCompleteInput = ({
  label,
  onSearch,
  placeholder,
  onSelect,
  defaultValue,
  defaultOptions = [],
  isMulti = false,
  defaultOptionsValue = null,
  value = null
}) => {
  const loadOptions = debounce((value, callback) => {
    onSearch(value).then((options) => callback(options));
  }, 1000);

  return (
    <div>
      {label && <Form.Label className="text-light">{label}</Form.Label>}
      <AsyncSelect
        cacheOptions
        defaultOptions={defaultOptions}
        defaultValue={defaultValue}
        defaultInputValue={defaultValue?.label}
        loadOptions={loadOptions}
        onChange={onSelect}
        placeholder={placeholder}
        classNamePrefix="search-autocomplete"
        isClearable
        isMulti={isMulti}
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary25: 'neutral60',
          },
        })}
        value={value || defaultOptionsValue || defaultValue}
      />
    </div>
  );
};

AutoCompleteInput.propTypes = {
  items: PropTypes.array,
  label: PropTypes.string,
  onSearch: PropTypes.func,
  onSelect: PropTypes.func,
  placeholder: PropTypes.string,
  defaultValue: PropTypes.any,
  className: PropTypes.string,
};

export default AutoCompleteInput;
